/** Name pools for generated people. Deliberately multicultural and neutral. */

export const FIRST_NAMES: readonly string[] = [
  'Amara', 'Nadia', 'Elif', 'Priya', 'Sofia', 'Mina', 'Lena', 'Yuki', 'Clara', 'Ines',
  'Rania', 'Thea', 'Noor', 'Dalia', 'Maya', 'Iris', 'Zara', 'Alba', 'Rosa', 'Suri',
  'Omar', 'Julian', 'Mateo', 'Kenji', 'Tariq', 'Andre', 'Felix', 'Idris', 'Rohan', 'Dimitri',
  'Nico', 'Samir', 'Caleb', 'Emeka', 'Arun', 'Lucas', 'Hugo', 'Yusuf', 'Marek', 'Tobias',
  'Sasha', 'Kai', 'Noa', 'Rowan', 'Alex', 'Jules', 'Remy', 'Eden', 'Ari', 'Quinn',
];

export const SURNAMES: readonly string[] = [
  'Okafor', 'Lindqvist', 'Haddad', 'Moreau', 'Batista', 'Nakamura', 'Varga', 'Delgado',
  'Ferreira', 'Kaur', 'Novak', 'Ibrahim', 'Sandoval', 'Whitfield', 'Kowalski', 'Mensah',
  'Bergström', 'Castillo', 'Rahimi', 'Tanaka', 'Duval', 'Petrov', 'Aliyev', 'Santos',
  'Larsen', 'Osei', 'Reyes', 'Fontaine', 'Adeyemi', 'Krishnan',
];

export const CHILD_NAMES: readonly string[] = [
  'Ada', 'Theo', 'Isla', 'Ravi', 'Juno', 'Milo', 'Sena', 'Ezra', 'Nila', 'Oren',
  'Lila', 'Kian', 'Vera', 'Arlo', 'Suri', 'Nael', 'Elsa', 'Otto', 'Anya', 'Rio',
];

export const PLAYER_NAME_SUGGESTIONS: readonly string[] = [
  'Avery Lane', 'Sam Okafor', 'Noor Haddad', 'Jules Moreau', 'Kai Nakamura',
  'Mira Delgado', 'Elliot Vance', 'Rin Tanaka', 'Adam Mensah', 'Tessa Novak',
];
